import {useMemo} from 'react';
import {useSearchParams} from 'react-router-dom';
import type {ContentSubmission} from '@/types/contentSubmission';
import useCampaignQuery from '@/hooks/queries/use-campaign-query';
import useContentSubmissionQuery from '@/hooks/queries/use-content-submission-query';
import type {ContentSubmissionBreadcrumbData} from '../breadcrumbDataTypes';
import {getContentSubmissionLabel} from '../breadcrumbUtils';

function useContentSubmissionBreadcrumbData(params: {
  campaignId?: string;
  contentSubmissionId?: string;
}): ContentSubmissionBreadcrumbData {
  const {campaignId, contentSubmissionId} = params;
  const [searchParams] = useSearchParams();
  const versionId = searchParams.get('versionId');

  const {campaign} = useCampaignQuery({
    campaignId,
    enabled: !!campaignId,
    include: [],
  });

  const {data: contentSubmission} = useContentSubmissionQuery({
    contentSubmissionId,
    enabled: !!contentSubmissionId,
  });

  const contentTypeLabel = useMemo(
    () =>
      getContentSubmissionLabel(
        contentSubmission as ContentSubmission | undefined,
        versionId
      ),
    [contentSubmission, versionId]
  );

  return {
    campaignName: campaign?.name,
    networkName: campaign?.network,
    contentTypeLabel,
  };
}

export default useContentSubmissionBreadcrumbData;
